import React from 'react'
import {isEmpty} from 'react-lf-tools'
import {CardMedia, IconButton} from '@mui/material'
import {shoppingCart as textsShoppingCart} from '../../../translate/Translate.jsx'
import {AddRounded as AddIcon, RemoveRounded as RemoveIcon} from '@mui/icons-material'

import food from '../../../assets/food.jpg'

import './listItems.scss'
import {getLocal} from "../../../hooks/useStorage/useStorage.jsx";

const ListItems = ({items, clickQuantity}) => {
    const allowFractioned = getLocal('allowFractioned', false)
    return <div className={'list-items'}>
        {items.map((item, i) => <div key={i} className={'items'}>
                <div>
                    <CardMedia
                        image={!isEmpty(item.image) ? item.image : food}
                        className={'card-media-item-image'}>
                    </CardMedia>
                </div>
                <div className={'div-item'}>
                    <label className={'label-product-item'}>
                        {item.product}
                    </label>
                    {(item.isCouponProduct) && <label className={'label-discount-item'}>
                        {textsShoppingCart.withDiscount}
                    </label>
                    }
                    <label className={'label-price-item'}>
                        {item.price.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        })}
                    </label>
                    {item.subitems.map((subItem, i) => <div className={'div-list-sub-items'} key={i}>
                            <label className={'label-amount-sub-item'}>
                                {subItem.amount}
                            </label>
                            <label className={'label-description-sub-item'}>
                                {subItem.option}
                            </label>
                        </div>
                    )}
                    {(item.observation) && <label className={'label-description'}>
                        {item.observation}
                    </label>}
                </div>
                {(!item.isCouponProduct) &&
                    <div className={'div-amount-item'}>
                        {(allowFractioned && item.fractioned) ?
                            <div className={'center'}>
                                <label className={'label-amount'}>
                                    {item.amount}
                                </label>
                            </div>
                            :
                            <>
                                <div className={'left'}>
                                    <IconButton onClick={() => clickQuantity(item, 'remove')}>
                                        <RemoveIcon className={'icon-information'}/>
                                    </IconButton>
                                </div>
                                <div className={'center'}>
                                    <label className={'label-amount'}>
                                        {item.amount}
                                    </label>
                                </div>
                                <div className={'right'}>
                                    <IconButton onClick={() => clickQuantity(item, 'add')}>
                                        <AddIcon className={'icon-information'}/>
                                    </IconButton>
                                </div>
                            </>
                        }
                    </div>
                }
            </div>
        )}
    </div>
}

export default ListItems
